import type { RouterConfig } from '@nuxt/schema'
import { parse, stringify } from '@/utils/querystring.js'

// https://router.vuejs.org/api/interfaces/routeroptions.html
export default <RouterConfig>{
  parseQuery: parse,
  stringifyQuery: stringify,
}
